import { KAddressMapDialog, KPhoneLink } from "kinnect-general";
import {
	VCard,
	VCardTitle,
	VCol,
	VDialog,
	VIcon,
	VList,
	VListItem,
	VListItemAvatar,
	VListItemContent,
	VMenu,
	VTooltip
} from "vuetify/lib";

export default {
	name: "KCustomerAddressCard",

	props: {
		address: Object,
		customer: Object
	},

	render() {
		const TagName = this.$vuetify.breakpoint.smAndDown ? VDialog : VMenu;

		return <TagName
			bottom
			closeOnContentClick={false}
			fullWidth
			maxWidth={360}
			minWidth={300}
			offsetY
			scopedSlots={{
				activator: ( { on } ) =>
					<VTooltip
						bottom
						on={on}
						scopedSlots={{
							activator: ( { on: onTooltip } ) =>
								<div
									class="pa-1 link--text"
									on={onTooltip}
									on={on}
									style="cursor: pointer;"
									vRipple
								>{this.customer.name}</div>
						}}
					>View customer details</VTooltip>
			}}
		>
			<VCard>
				<VCardTitle class="primary white--text">
					<VCol class="text-subtitle-1 pa-0" cols={12}>
						{this.customer.name}
					</VCol>

					<VCol class="text-caption pa-0" cols={12}>
						Address "{this.address.alias}"
					</VCol>
				</VCardTitle>

				<VList class="list--auto-height">
					{this.address.phone && <VListItem>
						<VListItemAvatar>
							<VIcon>phone</VIcon>
						</VListItemAvatar>

						<VListItemContent>
							<KPhoneLink
								icon={null}
								phone={this.address.phone}
							></KPhoneLink>
						</VListItemContent>
					</VListItem>}

					<VListItem>
						<VListItemAvatar>
							<VIcon>place</VIcon>
						</VListItemAvatar>

						<VListItemContent>
							<KAddressMapDialog
								activatorIcon={null}
								address={this.address}
							></KAddressMapDialog>
						</VListItemContent>
					</VListItem>
				</VList>
			</VCard>
		</TagName>;
	}
};
